import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Reservation = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass">
              <h4 className="event-alert">Reservation & Table Management</h4>
              <div className="row justify-content-between align-items-center">
                <div className="col-md-4">
                  <div className="search-box mt-0">
                    <form type="GET">
                      <input type="text" placeholder="Search" name="keyword1" />
                      <input type="submit" />
                    </form>
                  </div>
                </div>
              </div>

              <div class="col-12 row mx-0 mt-3">
                <h4 class="event-alert text-green col-12">
                  Integration Package Status : <span>Activated </span>{" "}
                </h4>
                <div class="merchant-row btns align_left px-0">
                  <button
                    class="btn btn_btnblue ml-0 mr-3"
                    type="button"
                    disabled="disabled"
                    name="submit"
                  >
                    Package Enabled
                  </button>
                </div>

                <div class="merchant-row btns span2 text-left ml-0"></div>
              </div>

              <div class="row-fluid">
                <ul class="package-ul">
                  <li class="package-li">
                    <div class="main-content">
                      <div class="heading-row">
                        <h4> Seven Rooms API </h4>
                        <small class="text-green">(Active)</small>
                        <span class="text-green icon">
                          <a href="#_">
                            <i class="edit-icon"></i>
                          </a>{" "}
                        </span>
                      </div>

                      <div class="content">
                        <div class="image">
                          <img
                            src="http://uat.gogmgo.com/img/seven_rooms_api-logo.jpg"
                            alt="grab-icon"
                          />{" "}
                        </div>

                        <div class="content-right">
                          <h4 class="event-alert">APIs AVAILABLE</h4>
                          <ul class="term-list">
                            <li class="yellow">New tickets</li>
                            <li class="green">Updated tickets</li>
                            <li class="green">Reservation confirmation</li>
                          </ul>

                          <div class="merchant-row btns clear">
                            <div class="m-0">
                              <div class="btns">
                                <a href="#_" class="btn btn_btnblue">
                                  Deactivate
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Reservation;
